import { FC, useRef, useState } from 'react'
import { Lead } from '@/api/types/crm.types'
import Button from '@UI/New/Button'
import { PlusCircleFilled } from '@ant-design/icons'
import classes from './index.module.css'
import LinksPurchasesList, {
  PurchasesLinksListHandle,
} from './components/PurchasesLinksList/PurchasesLinksList'
import CreateLinkModal from './components/CreateLinkModal/CreateLinkModal'
import useFullLeadModalAccess from '../../hooks/useFullLeadModalAccess'

interface LinksPurchasesBlockProps {
  lead: Lead
  excludedClassIds: number[]
  excludedDirectionIds: number[]
  refetchExcludedIds: () => void
}

const LinksPurchasesBlock: FC<LinksPurchasesBlockProps> = ({
  lead,
  excludedClassIds,
  excludedDirectionIds,
  refetchExcludedIds,
}) => {
  const { currentRole, ...access } = useFullLeadModalAccess()
  const [stateModal, setStateModal] = useState<{
    open: boolean
    type?: 'create'
  }>({
    open: false,
    type: 'create',
  })

  const linksListRef = useRef<PurchasesLinksListHandle>(null)

  return (
    <div className={classes.card}>
      <div className={classes.cardHeader}>
        <p className={classes.cardTitle}>Ссылки на покупки</p>
        {access.canManagePurchaseLinks && (
          <Button
            color="white"
            onClick={() => setStateModal({ open: true, type: 'create' })}
            rightContent={
              <PlusCircleFilled
                className={classes.iconPlusCircleFilled}
                onPointerEnterCapture={undefined}
                onPointerLeaveCapture={undefined}
              />
            }
          >
            Добавить ссылку на покупку
          </Button>
        )}
      </div>
      <div className={classes.cardContent}>
        <LinksPurchasesList ref={linksListRef} lead={lead} />
      </div>

      {/* Modals */}
      <CreateLinkModal
        lead={lead}
        excludedClassIds={excludedClassIds}
        excludedDirectionIds={excludedDirectionIds}
        open={stateModal.open && stateModal.type === 'create'}
        onClose={() => setStateModal({ open: false })}
        onSuccess={() => {
          linksListRef.current?.refetchQuery()
          setStateModal({ open: false })
        }}
      />
    </div>
  )
}

export default LinksPurchasesBlock
